// REACT_APP_ENV distingue stage da prod: NODE_ENV è "production" in ogni build
// (anche build:staging), quindi non basta a scegliere l'host giusto. Ogni app
// definisce process.env.REACT_APP_ENV nel proprio vite.config.js.
// Tutte le app usano l'API sull'host della webapp: il cookie di refresh è host-only.
export const API_URLS = {
  staging: 'https://stage-webapp.wine2trace.com/api',
  production: 'https://webapp.wine2trace.com/api',
};
export const BASE_URL =
  process.env.NODE_ENV === "production"
    ? API_URLS[process.env.REACT_APP_ENV] || API_URLS.production
    : 'http://localhost:3500/api';
